import React, { useEffect } from 'react'
import { VOLUME_CHECK_EVENTS } from '../StudentVolumeChecksConstants'

import useStudentPreChecks from '../../useStudentPreChecks'
import StudentInstruction from '../../Components/StudentInstruction'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'

export default function TeacherVolumeTestFailed({ handleRetry }) {

    const { logEvent } = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks })

    useEffect(() => {
        logEvent(VOLUME_CHECK_EVENTS.TEACHER_TEST_FAILED)
    }, [])

    return (
        <StudentInstruction>
            <p>See this <a href="https://help.amiralearning.com/s/article/Help-Amira-Can-t-Hear" target="_blank">help link</a> for troubleshooting steps or contact <a mailto="support@amiralearning.com">support@amiralearning.com</a> for assistance. Error code 1234</p>
            <button onClick={handleRetry}>Try Again</button>
        </StudentInstruction>
    )
}
